<template>
<div class="min-h-screen bg-gray-50">
<!-- 顶部导航 -->
<header class="bg-white shadow-sm">
<div class="max-w-7xl mx-auto px-4 h-16 flex items-center justify-between">
<div class="flex items-center space-x-2">
<el-icon class="text-blue-600 text-2xl"><Monitor /></el-icon>
<span class="text-xl font-medium">数据概览</span>
</div>
<div class="flex items-center space-x-6">
<el-button type="primary" class="!rounded-button" @click="jump(3)">
<el-icon><Document /></el-icon>
推广公司入口
</el-button>
<el-button type="primary" class="!rounded-button" @click="jump(4)">
<el-icon><Document /></el-icon>
平台活动入口
</el-button>
<el-button type="primary" class="!rounded-button" @click="jump(5)">
<el-icon><Document /></el-icon>
站内消息入口
</el-button>
<el-button type="success" class="!rounded-button" @click="jump(2)">
<el-icon><Office /></el-icon>
政商企入口
</el-button>
</div>
<el-button type="primary" class="!rounded-button" @click="jump(1)">
<el-icon><ChatDotRound /></el-icon>
AI入口
</el-button>
</div>
</header>
<main class="max-w-7xl mx-auto px-4 py-8">
<!-- 核心数据展示 -->
<div class="grid grid-cols-4 gap-6 mb-8">
<div v-for="(item, index) in coreStats" :key="index"
class="bg-white rounded-lg p-6 shadow-sm">
<div class="flex items-center justify-between mb-4">
<span class="text-gray-600">{{ item.label }}</span>
<el-icon :class="item.iconColor"><component :is="item.icon" /></el-icon>
</div>
<div class="flex items-end space-x-2">
<span class="text-3xl font-semibold">{{ item.value }}</span>

</div>
</div>
</div>
<!-- 统计图表 -->
<div class="ba_f outmain pad_20 ">
        <div class="shuju_title">
          <div class="shuju_title_text">
            <span>流量看板</span>
          </div>
        </div>
        <div class="flex-bet">
          <div class="bflex-7 outmain">
            <div id="mainEch" style="height: 400px;"></div>
          </div>
          <div class="bflex-3 mar_l20">
            <div class="flex-bet pad_20 flex-y-top">
              <div v-if="lldata.today">
                <p class="title6 fon_14">今日浏览量(pv)</p>
                <p class="fon_30 title35 lh16 pad_tb_20 wei">{{ lldata.today.pv }}</p>
                <div class="flex">
                  <p class="fon_12 title6 lh25">昨日： {{ lldata.yesterday.pv }}</p>
                </div>
              </div>
            </div>
            <div class="flex-bet pad_20 flex-y-top mar_t20">
              <div v-if="lldata.today ">
                <p class="title6 fon_14">今日访客数(uv)</p>
                <p class="fon_30 title35 lh16 pad_tb_20 wei">{{ lldata.today.uv }}</p>
                <div class="flex">
                  <p class="fon_12 title6 lh25">昨日： {{ lldata.yesterday.uv }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

<div class="grid grid-cols-2 gap-6 mb-8">
<div class="bg-white rounded-lg p-6 shadow-sm col-span-2">
<div class="flex items-center justify-between mb-4">
<h3 class="text-lg font-medium">各类用户增长趋势</h3>
<el-radio-group v-model="timeRange" size="small" @change="handleTimeRangeChange">
<el-radio-button label="week">周</el-radio-button>
<el-radio-button label="month">月</el-radio-button>
<el-radio-button label="year">年</el-radio-button>
</el-radio-group>
</div>
<div ref="userTrendChart" style="height: 300px"></div>
</div>
</div>
</main>
</div>
</template>

<script>
import * as echarts from 'echarts';
import UserApi from '@/api/user.js';
import IndexApi from "@/api/index.js";
import {
  setSessionStorage,
  getSessionStorage
} from '@/utils/base'

export default {
  data() {
    return {
      ssdata: {},//实时概况
      lldata: {},//流量看板
      echarts1_option: {
        color: ['#4284ED', '#42CCF0'],
        tooltip: {
          trigger: 'axis',
          formatter: (params) => {
            var time = '';
            for (var i = 0; i < params.length; i++) {
              var numbers = '</br>' + params[i].seriesName + '：' + params[i].value;
              time += numbers
            }
            return time
          }
        },
        legend: {
          data: ['今日浏览量', '今日访客数']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisTick: { show: false },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#333',
              fontSize: '12'
            }
          },
          axisLine: {
            lineStyle: {
              color: '#f7f7f7',
              width: 2,
            }
          },
          data: []
        },
        yAxis: {
          type: 'value',
          axisTick: { "show": false },
          axisLine: { "show": false },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#333',
              fontSize: '12'
            }
          },
          splitLine: {
            lineStyle: {
              type: 'dotted',
              color: '#DDDDDD',
            },
            show: true
          }
        },
        series: [
          {
            name: '浏览量',
            type: 'line',
            stack: '总量',
            smooth: true,
            data: []
          },
          {
            name: '访客数',
            type: 'line',
            stack: '总量',
            smooth: true,
            data: []
          }
        ]
      },
      coreStats: [
        {
          label: '政府用户',
          value: '',
          growth: '',
          icon: 'Office',
          iconColor: 'text-blue-500'
        },
        {
          label: '企业用户',
          value: '',
          growth: '',
          icon: 'Briefcase',
          iconColor: 'text-green-500'
        },
        {
          label: '商会机构',
          value: '',
          growth: '',
          icon: 'Collection',
          iconColor: 'text-yellow-500'
        },
        {
          label: '平台浏览量',
          value: '',
          growth: '',
          icon: 'View',
          iconColor: 'text-purple-500'
        }
      ],
      timeRange: 'month',
      trendChart: null // 保存图表实例
    }
  },
  mounted() {
    this.getIndex();
    this.fetchCoreStats();
    this.initChart();
  },
  methods: {
    jump(type) {
      if (type == 1) {
        window.open('https://aifast.shanglianweilai.com/')
      } else if (type == 2) {
        this.$router.push("/plus/supply/index");
      } else if (type == 3) {
        this.$router.push("/plus/company/index");
      } else if (type == 4) {
        this.$router.push("/plus/activity/index");
      } else if (type == 5) {
        this.$router.push("/plus/msg/index");
      }
    },

    getIndex() {
      let self = this;
      IndexApi.getCounts({})
        .then((data) => {
          console.log(data);
          self.loading = false;
          setSessionStorage('dictval', data.data.dictval);
          //流量看板----
          self.lldata = data.data.daily
          this.echarts1_option.series[0].data = data.data.dailys.chart.series['今日浏览量'];
          this.echarts1_option.series[1].data = data.data.dailys.chart.series['今日访客数'];
          this.echarts1_option.xAxis.data = data.data.dailys.chart.xAxis
          this.llkb()
        })
        .catch((error) => {});
    },

    llkb() {
      let myChart = echarts.init(document.getElementById('mainEch'))
      myChart.setOption(this.echarts1_option, true)
    },

    // 初始化趋势图表
    initChart() {
      this.trendChart = echarts.init(this.$refs.userTrendChart);
      this.fetchUserTrend();
    },

    // 处理时间范围变化
    handleTimeRangeChange() {
      this.fetchUserTrend();
    },

    async fetchCoreStats() {
      try {
        UserApi.core_stats().then(res => {
          this.coreStats = res.data.data
        })
      } catch (error) {
        console.error('获取核心数据失败:', error);
      }
    },

    fetchUserTrend() {
      var self = this;
      // 显示加载状态
      if (this.trendChart) {
        this.trendChart.showLoading();
      }

      UserApi.user_trend({ range: self.timeRange }).then(res => {
        var chartData = res.data.data;
        if (this.trendChart) {
          this.trendChart.hideLoading();
          this.trendChart.setOption({
            animation: false,
            tooltip: { trigger: 'axis' },
            legend: {
              data: ['政府用户', '企业用户', '商会用户', '新增用户'],
              right: '5%'
            },
            grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: chartData.xAxis
            },
            yAxis: [
              { type: 'value', name: '用户数量', position: 'left' },
              { type: 'value', name: '新增用户', position: 'right' }
            ],
            series: [
              { name: '政府用户', type: 'line', smooth: true, data: chartData.series.government },
              { name: '企业用户', type: 'line', smooth: true, data: chartData.series.enterprise },
              { name: '商会用户', type: 'line', smooth: true, data: chartData.series.organization },
              { name: '新增用户', type: 'line', yAxisIndex: 1, smooth: true, data: chartData.series.new_users }
            ]
          });
        }
      }).catch(error => {
        console.error('获取趋势数据失败:', error);
        if (this.trendChart) {
          this.trendChart.hideLoading();
        }
      });
    }
  },

  // 监听窗口大小变化，重新渲染图表
  beforeDestroy() {
    if (this.trendChart) {
      this.trendChart.dispose();
    }
  }
}
</script>

<style scoped>
/* 添加响应式设计 */
@media (max-width: 768px) {
  .grid.grid-cols-4 {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .grid.grid-cols-2 {
    grid-template-columns: 1fr;
  }
}

/* 图表容器样式 */
#mainEch, [ref="userTrendChart"] {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/home/home.vue